import React, { useEffect, useState } from 'react'
import { ycrAssetAction } from '../../../../store/actions/user/ycrAssetAction';
import { useDispatch, useSelector } from 'react-redux';
import { Filters } from '../../../../constant';
import { DataTableWithCustomPagination } from '../../../../shared/DataTableWithCustomPagination';
import DataTableColumnHeader from '../../../../components/table-components/data-table-column-header';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../../components/ui/dropdown';
import { DotsHorizontalIcon, Pencil2Icon } from '@radix-ui/react-icons';
import { Button } from '../../../../components/ui/button';
import YcrSubModel from './models/YcrSubTypeModel';

const YcrAssetContent = (props) => {
    const { fetchData,countries } = props
    const { ycrData, isLoading, metaData, ycrAssetData } = useSelector(state => state)
    const dispatch = useDispatch()
    const [editedData, setEditedData] = useState(null)
    // pagination
    const [currentPage, setCurrentPage] = useState(Filters.PAGE);
    const [perPage, setPerPage] = useState(Filters.OBJ.perPage); // Default per page value
    const [totalRecords, setTotalRecords] = useState(Filters.OBJ.totalRecords)
    const [totalPages, setTotalPages] = useState(Filters.OBJ.totalPages)
    const [openModel, setOpenModel] = useState(false)

    useEffect(() => {
        console.log(countries)
        dispatch(ycrAssetAction({
            countryIds: countries,
            interestRateDataTypeIds: [fetchData?.id],
            page: currentPage,
            perPage: perPage
        }))

    }, [fetchData, currentPage, perPage])

    const handleEditAsset = (data) => {
        setEditedData(data)
        setOpenModel(true)
    }



    // Pagination functions
    const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;

    const data = ycrAssetData && ycrAssetData?.records?.length ? ycrAssetData?.records.map((item, index) => {
        return {
            indexNum: indexOfFirstItem + index + 1,
            slug: item.slug,
            maturity:item?.maturity ?? "-",
            Name: item.interestRateDataType.type
        }
    }) : [];

    useEffect(() => {
        if (data) {
            setTotalRecords(data?.length)
            setTotalPages(data?.length / perPage)
        }
    },[data]);



    const columns = [
        {
            accessorKey: "indexNum",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="index" />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.indexNum}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "Name",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Curve" />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.Name}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "slug",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Tenor" />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.maturity}</span>
            },
            enableSorting: true,
        },
        // {
        //     id: "actions",
        //     enableHiding: false,
        //     header: <span className="flex items-center justify-end">Action</span>,
        //     cell: ({ row }) => {
        //         return (
        //             <div className="flex items-center justify-end">
        //                 <DropdownMenu>
        //                     <DropdownMenuTrigger asChild>
        //                         <Button variant="ghost" className="p-0">
        //                             <span className="sr-only">Open menu</span>
        //                             <DotsHorizontalIcon strokeWidth={"2.2"} className="h-5 w-5 text-textV2" />
        //                         </Button>
        //                     </DropdownMenuTrigger>
        //                     <DropdownMenuContent align="end">
        //                         <DropdownMenuItem className={`text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2`} onClick={() => handleEditAsset(row?.original)}> <span className='w-5 h-5 bg-themeV2/10 flex items-center justify-center rounded-[4px]'><Pencil2Icon strokeWidth={"2.2"} className='text-themeV2 w-4 h-4' /> </span> Edit Asset</DropdownMenuItem>
        //                     </DropdownMenuContent>
        //                 </DropdownMenu>
        //             </div>
        //         )
        //     },
        // }

    ]


    return (
        <div>
            <DataTableWithCustomPagination loadData={isLoading} data={data} columns={columns} filterName={'Name'} isCollViewHide={true}
                setPerPage={setPerPage} perPage={perPage} totalRecords={totalRecords} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}
            />
            <YcrSubModel show={openModel} onHide={setOpenModel} data={editedData} />
        </div>
    )
}

export default YcrAssetContent